module.exports = __webpack_public_path__ + "static/media/สมัยก่อนประวัติศาสตร์.13bbab6d.JPG";